module.exports = __webpack_public_path__ + "img/feel-good-stretches-sternum-stretch.7b703c20.png";